import React from "react";

const TransferBanner = ({ isTransferStudent }) => {
  if (!isTransferStudent) return <></>;
  return (
    <div className=" mr-3 border rounded">
      <div class="p-3 mb-2 bg-danger text-white text-center">
        Student has been transferred from this application. You can only view
        the charges.
      </div>
    </div>
  );
};

export default TransferBanner;
